/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Approval_Passed_LabelInputs */



/**
* | output |
* | --- |
* | "Approval Passed" |
*
* @param {Style_Guide_Manager_Approval_Passed_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_approval_passed_label = /** @type {((inputs?: Style_Guide_Manager_Approval_Passed_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Approval_Passed_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Approbation reussie")
	if (locale === "de") return /** @type {LocalizedString} */ ("Genehmigung erteilt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Approvazione superata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Одобрение получено.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aprobación aprobada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已批准")
	if (locale === "ja") return /** @type {LocalizedString} */ ("承認が通過しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनुमोदन पारित हो गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aprovação concedida.")
	return /** @type {LocalizedString} */ ("Approval Passed")
});